import $ from 'jquery';
import naja from 'naja';

const initTaskDetail = () => {
    const addContractBtn = document.querySelector('.btn-add-contract');
    if (addContractBtn) {
        addContractBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const form = this.closest('form');
            const formData = new FormData(form);

            // Mapování polí
            const data = {
                client: formData.get('client'),
                assigned: formData.get('assigned'),
                coop: formData.getAll('coop[]'),
                description: form.querySelector('[name="description"]')?.value || '',
            };

            // ID ticketu, ze kterého zakázka vzniká — díky němu se po uložení
            // rovnou vytvoří vazba ticket <-> zakázka (úkol 855).
            // U nezaloženého ticketu atribut neexistuje a chová se to jako dřív.
            const ticketId = this.getAttribute('data-ticket-id');
            if (ticketId) {
                data.ticketId = ticketId;
            }

            // Pokud je použit Summernote (wysiwyg), musíme z něj dostat aktuální obsah
            const $desc = $(form).find('[name="description"]');
            if ($desc.hasClass('wysiwyg') && $desc.next('.note-editor').length > 0) {
                try {
                    data.description = $desc.summernote('code');
                } catch (e) {
                    console.error('Summernote error:', e);
                }
            }

            const postForm = document.createElement('form');
            postForm.method = 'POST';
            postForm.action = this.getAttribute('href');

            for (const key in data) {
                if (Array.isArray(data[key])) {
                    data[key].forEach(val => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = key + '[]';
                        input.value = val;
                        postForm.appendChild(input);
                    });
                } else {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = data[key];
                    postForm.appendChild(input);
                }
            }

            document.body.appendChild(postForm);
            postForm.submit();
        });
    }

    function syncDescriptionHeight() {
        var rightCol = document.getElementById('ticket-form-right');
        var descCol = document.getElementById('ticket-description-col');
        if (!rightCol || !descCol) return;
        var label = document.getElementById('ticket-description-label');
        var labelH = label ? label.offsetHeight + 4 : 0;
        var targetH = rightCol.offsetHeight - labelH + 6;
        if (targetH < 100) return;
        var editor = descCol.querySelector('.note-editor');
        if (editor) {
            editor.style.height = targetH + 'px';
            var editable = editor.querySelector('.note-editable');
            if (editable) editable.style.height = (targetH - 10) + 'px';
        }
    }

    setTimeout(syncDescriptionHeight, 0);
    window.addEventListener('resize', syncDescriptionHeight);
};

$(initTaskDetail);
naja.addEventListener('success', initTaskDetail);
